import tasaCeroBAC from "./image.png";

export const tasaCero = tasaCeroBAC;
